import Logo from './DownloadIcon.svg';

type ImageProps = React.JSX.IntrinsicElements['div'] & {
  width?: string;
}

export const DownloadIcon = ({width = "11px", ...props}: ImageProps) => <div {...props}><img src={Logo} width={width} style={{paddingBottom: '1px'}}/></div>
export default DownloadIcon;
